import { NgModule } from '@angular/core';

import { BoldHoverDirective } from './boldhover.directive';
import { HiddenDirective } from './hidden.directive';
import { HighlightDirective } from './highlight.directive';
import { LeftPadDirective } from './leftpad.directive';
import { OnlyNumbersDirective } from './onlyNumbers.directive';
import { TrimDirective } from './trim.directive';
import { TrimPlusDirective } from './trimPlus.directive';
import { UnderlineDirective } from './underline.directive';
import { AutofocusDirective } from './autofocus.directive';
import { OnlyCurrencyDirective } from './onlyCurrency.directive';

@NgModule({
    declarations: [
        BoldHoverDirective,
        HiddenDirective,
        HighlightDirective,
        LeftPadDirective,
        OnlyNumbersDirective,
        TrimDirective,
        TrimPlusDirective,
        UnderlineDirective,
        AutofocusDirective,
        OnlyCurrencyDirective
    ],
    exports: [
        BoldHoverDirective,
        HiddenDirective,
        HighlightDirective,
        LeftPadDirective,
        OnlyNumbersDirective,
        TrimDirective,
        TrimPlusDirective,
        UnderlineDirective,
        AutofocusDirective,
        OnlyCurrencyDirective
    ],
})
export class DirectiveModule { }



// WEBPACK FOOTER //
// ./src/app/shared/utils/directives/directives.module.ts